import { CONSTANTS } from "@data"

const { EVENTS } = CONSTANTS
const { KEYS } = EVENTS
const { ARROWS } = KEYS

/**
 * Get the available event key, keycode, or which thingie
 * @param  {object} evt - event object
 * @return {string}     - typically the event type
 */
const keyCodeOrKey = evt => {
  if ("key" in evt) return evt.key
  if ("keyCode" in evt) return evt.keyCode
  if ("which" in evt) return evt.which
  return window.event
}

/**
 * Determine the type of keyboard event by comparing against the EVENTS.KEYS constants
 * @param  {object} evt    - event object
 * @param  {array} evtKey - array constants that are arrays of possible values
 * @return {boolean}        - true/false
 */
const isEventOfType = (evt, evtKey) => evtKey.includes(keyCodeOrKey(evt))

/**
 * Create an object that describes what keyboard event fired
 * @param  {object} e - event object from listener
 * @return {object}   - object describing the event with booleans
 */
function keyId(e) {
  const keys = {
    shift: !!e.shiftKey,
    escape: isEventOfType(e, KEYS.ESC),
    tab: isEventOfType(e, KEYS.TAB),

    up: isEventOfType(e, ARROWS.UP),
    right: isEventOfType(e, ARROWS.RIGHT),
    down: isEventOfType(e, ARROWS.DOWN),
    left: isEventOfType(e, ARROWS.LEFT),

    space: isEventOfType(e, KEYS.SPACE),
    enter: isEventOfType(e, KEYS.ENTER)
  }

  return Object.assign(keys, {
    rightOrDown: keys.right || keys.down,
    upOrLeft: keys.left || keys.up
  })
}

const keyboard = {
  keyId
}

export default keyboard
